import ShipNotificationsViewer from './ShipNotificationsViewer'

export default ShipNotificationsViewer
